'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "isInteractive", "className", "onClick", "onKeyDown", "href", "children", "disabled", "as", "borderRadius", "minBlockSize", "padding", "paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd", "hoverBackgroundColor", "activeBackgroundColor", "hasFocus", "hoverAnimationDuration"];
import React, { useCallback, useRef } from 'react';
import { BoxComponent } from "./Box.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet } from "../../styles/index.mjs";
export var Box = /*#__PURE__*/React.forwardRef(function Box(_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'naked' : _ref$variant,
    isInteractive = _ref.isInteractive,
    className = _ref.className,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    href = _ref.href,
    children = _ref.children,
    disabled = _ref.disabled,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    borderRadius = _ref.borderRadius,
    minBlockSize = _ref.minBlockSize,
    padding = _ref.padding,
    paddingBlockStart = _ref.paddingBlockStart,
    paddingBlockEnd = _ref.paddingBlockEnd,
    paddingInlineStart = _ref.paddingInlineStart,
    paddingInlineEnd = _ref.paddingInlineEnd,
    hoverBackgroundColor = _ref.hoverBackgroundColor,
    activeBackgroundColor = _ref.activeBackgroundColor,
    hasFocus = _ref.hasFocus,
    hoverAnimationDuration = _ref.hoverAnimationDuration,
    props = _objectWithoutProperties(_ref, _excluded);
  var isInteractiveSetOrImplied = isInteractive !== null && isInteractive !== void 0 ? isInteractive : !!onClick || !!href;
  var colorSet = undefined;
  if (variant === 'contrasting') {
    var _props$colorSet;
    colorSet = (_props$colorSet = props.colorSet) !== null && _props$colorSet !== void 0 ? _props$colorSet : 'invertedLight';
  }
  var boxRef = useRef(null);
  if (ref) {
    boxRef = ref;
  }

  // Treat {Spacebar} and {Enter} presses as clicks if onClick is passed.
  var handleKeyDown = useCallback(function (e) {
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    if (onClick) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        var _boxRef$current;
        e.preventDefault();
        (_boxRef$current = boxRef.current) === null || _boxRef$current === void 0 || _boxRef$current.click();
      }
    }
  }, [onKeyDown, onClick]);
  return /*#__PURE__*/React.createElement(BoxComponent, Object.assign({
    as: href ? 'a' : as,
    $variant: variant,
    className: addColorSet(colorSet, className),
    ref: boxRef,
    tabIndex: isInteractiveSetOrImplied ? 0 : undefined,
    $isInteractive: isInteractiveSetOrImplied,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    href: disabled ? undefined : href,
    disabled: disabled,
    "data-encore-id": ENCORE_DATA_IDS.Box,
    $borderRadius: borderRadius,
    $minBlockSize: minBlockSize,
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd,
    $hoverBackgroundColor: hoverBackgroundColor,
    $activeBackgroundColor: activeBackgroundColor,
    $hasFocus: hasFocus,
    $hoverAnimationDuration: hoverAnimationDuration
  }, props), children);
});